import { useEffect, useState } from 'react';
import { useCreditAccount } from '../../hooks/useCreditAccount';
import { formatCredit } from '../../services/credit';
import { i18nService } from '../../services/i18n';

/** 账户按钮内的钱包/套餐摘要；两类余额分开展示，不把企业共享池相加成个人资产。 */
export default function SidebarCreditBalance() {
  const { account, status } = useCreditAccount();
  const [language, setLanguage] = useState(i18nService.getLanguage());
  useEffect(() => i18nService.subscribe(() => setLanguage(i18nService.getLanguage())), []);
  const stale = status !== 'ready' && status !== 'idle';
  const locale = language === 'en' ? 'en-US' : language === 'zh-TW' ? 'zh-TW' : 'zh-CN';
  if (account?.mode === 'off') return null;
  const t = (key: string) => i18nService.t(`credit${key}`);
  const label = [
    account?.mode === 'shadow' ? t('ShadowShort') : null,
    stale ? t('StaleShort') : null,
    `${t('Wallet')}: ${formatCredit(account?.wallet_mcr, account?.credit_per_quota ?? 0, locale)}`,
    `${t('Subscription')}: ${account?.subscription_unlimited ? '∞' : formatCredit(account?.subscription_mcr_remain, account?.credit_per_quota ?? 0, locale)}`,
  ].filter(Boolean).join(' · ');
  return <span data-testid="sidebar-credit-balance" className="block truncate text-[10px] dark:text-claude-darkTextSecondary text-claude-textSecondary" title={label}>
    {label}
  </span>;
}
